module.exports = __webpack_public_path__ + "static/media/1027971.267b8d1c.png";